<template>
  <div class="cbg-auth__wrapper">
    <h2 class="cbg-auth__title">{{formTitle}}</h2>
    <p class="cbg-auth__subtitle">{{subtitleText}} <button class="cbg-auth__subtitle-link" @click="toggleAccount">{{toggleButtonText}}</button></p>
    <form class="cbg-auth__form" method="POST" @submit.prevent="signHandler">
      <Input ref="emailInput" v-model="email" class-name="cbg-auth__form-input" input-name="Email" :is-required="true" validation-type="email"/>
      <Input ref="userInput" v-if="!haveAccount" v-model="login" class-name="cbg-auth__form-input" input-name="Username" :is-required="true" validation-type="login"/>
      <PasswordInput ref="passwordInput" v-model="password" class-name="cbg-auth__form-input" input-name="Password" :is-new="!haveAccount" :email-string="emailString"/>
      <PasswordInput ref="confirmInput" v-if="!haveAccount" v-model="confirmPassword" class-name="cbg-auth__form-input" input-name="Confirm Password" :confirm-password="password"/>
      <div v-if="haveAccount" class="cbg-auth__form-additional">
        <div class="cbg-auth__form-remember">
          <input v-model="isRemember" id="remember" class="cbg-auth__form-remember__input" type="checkbox" @change="updateRemember">
          <label class="cbg-auth__form-remember__label" for="remember">Remember me</label>
        </div>
        <button class="cbg-auth__form-forgot" @click.prevent="updateStep" type="button">Forgot password?</button>
      </div>
      <p v-else class="cbg-auth__form-info">By signing up, you agree with our <a class="cbg-auth__form-info__link" target="_blank" href="https://cricketbettingguru.net/terms-conditions/">Terms and Conditions</a> and <a class="cbg-auth__form-info__link" target="_blank" href="https://cricketbettingguru.net/cookies-policy/">Privacy Policy</a>.</p>
      <button class="cbg-auth__form-button" :disabled="isDisabled || isLoading" type="submit">
        <span class="cbg-auth__form-button__text">{{formTitle}}</span>
        <template v-if="!isLoading">
          <Svg v-if="haveAccount" class-name="cbg-auth__form-button__ico" icon-id="#log-in"/>
          <Svg v-else class-name="cbg-auth__form-button__ico" icon-id="#sign-up"/>
        </template>
        <span v-else class="spinner"></span>
      </button>
    </form>
<!--    <div class="cbg-auth__sm">-->
<!--      <p class="cbg-auth__sm-offer">Or continue with a Social Account</p>-->
<!--      <div class="cbg-auth__sm-buttons">-->
<!--        <a class="cbg-auth__sm-buttons__item" :href="googleUrl">-->
<!--          <Svg class-name="cbg-auth__sm-buttons__item-ico" icon-id="#google"/>-->
<!--          <span class="cbg-auth__sm-buttons__item-text">Continue with Google</span>-->
<!--        </a>-->
<!--&lt;!&ndash;        <a class="cbg-auth__sm-buttons__item" :href="facebookUrl">&ndash;&gt;-->
<!--&lt;!&ndash;          <Svg class-name="cbg-auth__sm-buttons__item-ico" icon-id="#facebook"/>&ndash;&gt;-->
<!--&lt;!&ndash;          <span class="cbg-auth__sm-buttons__item-text">Continue with Facebook</span>&ndash;&gt;-->
<!--&lt;!&ndash;        </a>&ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import Svg from "@/components/global/Svg.vue";
import Input from "@/components/elements/Input.vue";
import PasswordInput from "@/components/elements/PasswordInput.vue";
import {formValidation} from "@/mixins/formValidation";
import {sendRequests} from "@/mixins/sendRequests";
import {requestValidation} from "@/mixins/requestValidation";
export default {
  name: 'AuthForm',
  components: {
    PasswordInput,
    Svg,
    Input
  },
  mixins: [requestValidation, formValidation, sendRequests],
  data() {
    return {
      isRemember: false,
      haveAccount: true,
      email: '',
      password: '',
      confirmPassword: '',
      login: '',
      // facebookUrl: '',
      // googleUrl: ''
    }
  },
  computed: {
    formTitle() {
      return this.haveAccount ? 'Log In' : 'Sign Up';
    },
    subtitleText() {
      return this.haveAccount ? "Don't have an account?" : "Already have an account?";
    },
    toggleButtonText() {
      return this.haveAccount ? 'Sign up' : 'Log in';
    },

    emailString() {
      return this.email ? this.email.split("@")[0] : '';
    }
  },
  methods: {
    toggleAccount() {
      this.haveAccount = !this.haveAccount;
    },

    updateStep() {
      this.updateContext && this.updateContext('step', 1);
    },

    signHandler() {
      this.isValidAll();

      if(!this.isDisabled) {
        this.haveAccount ? this.loginUserRequest() : this.registerUserRequest();
      }
    },

    updateRemember() {
      localStorage.setItem('cbgIsRemember', this.isRemember);
    },

    // async fetchProviders() {
    //   const response = await this.getProviders();
    //
    //   if (response && response.providers) {
    //     response.providers.forEach(provider => {
    //       // if (provider.provider === 'Facebook') {
    //       //   this.facebookUrl = provider.redirectUrl;
    //       // }
    //       if (provider.provider === 'Google') {
    //         this.googleUrl = provider.redirectUrl;
    //       }
    //     });
    //   }
    // },

    checkUrl() {
      if (/^\/register\/?$/.test(window.location.pathname)) {
        this.haveAccount = false;
      }
    }
  },

  async mounted() {
    // await this.fetchProviders();
    this.checkUrl();
  },
}
</script>